import { Col } from 'antd';
import styled from 'styled-components';

const DivFlexCol = styled(Col)`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: ${props => (props.justify ? props.justify : 'flex-start')};
`;

export default DivFlexCol;



// WEBPACK FOOTER //
// ./src/styled/DivFlexCol.js